import { getChildrensIsActive } from '~/utils/helpers';
import type { SidebarLink } from '~/interfaces/sidebar.interface';

const useEpizootologyLinks = () => {
  const { t } = useI18n();
  const route = useRoute();
  const uniqueKey = getUniqueKey();

  const childrens = computed(() => {
    return [
      {
        level: 2,
        isVisible: true,
        href: '/diseases',
        icon: ``,
        label: t('routes.diseases'),
        isActive: route.path.includes('/diseases'),
      },
      {
        level: 2,
        isVisible: true,
        href: '/injection-places',
        icon: ``,
        label: t('routes.injection-places'),
        isActive: route.path.includes('/injection-places'),
      },
      {
        level: 2,
        isVisible: true,
        href: '/injection-ways',
        icon: ``,
        label: t('routes.injection-ways'),
        isActive: route.path.includes('/injection-ways'),
      },
    ];
  });

  const links = computed(() => {
    const data = [{ childrens: childrens.value }];
    const isActive = getChildrensIsActive(data as SidebarLink[]);
    return [
      {
        uniqueKey,
        level: 1,
        isVisible: true,
        href: '/epizootology',
        icon: ``,
        label: t('routes.epizootology'),
        isActive,
        childrens: childrens.value,
      },
    ];
  });

  return { links };
};
export default useEpizootologyLinks;
